import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const padding = css`
  padding: 3px;
`

const Container = styled.div`
  ${padding}
  background-color: ${(props) => props.backgroundColor};
  border-radius: 2px;
  display: flex;
  flex-direction: row;
`

const Icon = styled.div`
  ${padding}
  align-self: center;
  line-height: 11px;
`

const Title = styled.div`
  ${padding}
  color: ${(props) => props.color};
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 11px;
`

const Description = styled.div`
  ${padding}
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 11px;
  line-height: 11px;
`

const StatusLabelComponent = ({
  backgroundColor,
  description,
  icon,
  title,
  titleColor,
}) => (
  <Container backgroundColor={backgroundColor}>
    <Icon>{icon}</Icon>
    <Title color={titleColor}>{title}</Title>
    <Description>{description}</Description>
  </Container>
)

StatusLabelComponent.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
}

export default StatusLabelComponent
